/* eslint-disable @typescript-eslint/no-unused-vars */
import { iReviewFormValues } from '@services/ReviewService';
import { Field, getIn, useFormikContext } from 'formik';
import { ReactElement, useEffect, useState } from 'react';
import gridStyles from '@pages/forms/Grid.module.scss';
import { AddressFieldAccessible, Alert, ContactInputWithExperian, EmailFieldWithExperian, Modal, ReviewAddressModal, TextInput, TileRadioAccessible } from '@components';
import { tile } from '@interfaces/interfaces';
import { reviewInfoDisplayObject } from '@services/FormFieldConfig';
import { FormType } from '@constants/forms';
import styles from './ThirdPartyFormReview.module.scss';

function ThirdPartyFormReview(): ReactElement {
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { values }: { values: iReviewFormValues; } = useFormikContext<iReviewFormValues>();
    const [circumstances, setCircumstances] = useState('');
    const pageFields = reviewInfoDisplayObject.pages.ThirdPartyRepContactInformation.fields;
    const pageTitles = reviewInfoDisplayObject.pages.ThirdPartyRepContactInformation;
    const [modal, setModal] = useState({
      show: false,
      title: '',
      content: <></>,
      contentClass: '',
    });

    const YesValue = (): ReactElement => (
      <>
        <div>Yes</div>
      </>
    );
    const NoValue = (): ReactElement => (
      <>
        <div>No</div>
      </>
    );
    const ThirdPartyValue = (): ReactElement => (
      <>
        <div>Authorised representative</div>
      </>
    );
    const PersonOnFineValue = (): ReactElement => (
      <>
        <div>Person who received the fine</div>
      </>
    );
    // const BothValue = (): ReactElement => (
    //   <>
    //     <div>Both</div>
    //   </>
    // );
    const ReceiveApplicationViaEmail: tile[] = [
      {
        body: <YesValue />,
        value: 'true',
      },
      {
        body: <NoValue />,
        value: 'false',
      },
    ];
    const CorrespondenceRecipient: tile[] = [
      {
        body: <ThirdPartyValue />,
        value: 'Authorised representative',
      },
      {
        body: <PersonOnFineValue />,
        value: 'Fineholder',
      },
      // {
      //   body: <BothValue />,
      //   value: 'Both'
      // }
    ];

    useEffect(() => {
      if (getIn(values, 'selectTheOption')[0] === 'SelectedGroundInfo1') {
        setCircumstances('exceptional');
      }
      if (getIn(values, 'selectTheOption')[0] === 'SelectedGroundInfo4') {
        setCircumstances('special');
      }
    }, []);

    return (
      <>
        <span className="vfH2">{pageTitles.pageTitle}</span>
        <p>We need <b>your</b> details here, as the authorised representative.</p>
        <p>All fields are required unless specified otherwise</p>
        <div className={gridStyles.form}>
          <div className={gridStyles.gridColFull}>
            <Field component={TextInput} name={pageFields.givenName.formikName} title={pageFields.givenName.title} isMandatory />
          </div>
          <div className={gridStyles.gridColFull}>
            <Field component={TextInput} name={pageFields.familyName.formikName} title={pageFields.familyName.title} isMandatory />
          </div>
          <div className={gridStyles.gridColFull}>
            <Field component={TextInput} name={pageFields.relationshipToFineholder.formikName} title={pageFields.relationshipToFineholder.title} isMandatory />
          </div>
          <div className={gridStyles.gridColFull}>
            <Field component={TextInput} name={pageFields.organisationName.formikName} title={pageFields.organisationName.title} isMandatory />
          </div>
          <div className={gridStyles.gridColFull}>
            <AddressFieldAccessible name={pageFields.postalAddress.formikName} title={pageFields.postalAddress.title} manualAddressText="Enter address manually" isMandatory />
          </div>
          <Modal close={() => setModal({ ...modal, show: false })} {...modal} />
          <div>
            <button
              type="button"
              style={{ border: 'none', color: '#0072ce', backgroundColor: 'transparent', cursor: 'pointer', marginTop: '5px', textDecoration: 'underline' }}
              onClick={() => {
                  const modalTitle = 'Have you moved recently?';
                  setModal({
                    show: true,
                    title: modalTitle,
                    content: ReviewAddressModal(),
                    contentClass: '',
                  });
                }}>
              Have you moved recently?
            </button>
          </div>
          {/* TODO to Accessible version of component when branch is merged to uptodate */}
          <div className={gridStyles.gridColFull}>
            <Field
              component={ContactInputWithExperian}
              name={pageFields.contactNumber.formikName}
              title="Contact phone number"
              isMandatory
              orientationRow
              obligationNumber={values.OBLIGATION_NUMBER}
              formName={FormType.REVIEW}
              secondaryContact={false}
              hasPrimaryNumberType={false}
              warningMessage="ContactNumberYourDetailsThirdPartyWarning"

            />
          </div>
          <div className={gridStyles.gridColFull}>
            <Field
              component={EmailFieldWithExperian}
              name={pageFields.emailAddress.formikName}
              title="Email"
              isMandatory
              orientationRow
              obligationNumber={values.OBLIGATION_NUMBER}
              formName={FormType.REVIEW}
              noEmailField={pageFields.noEmail.formikName}
              currentSP={pageFields.noEmail.title}
              warningMessage="EmailYourDetailsThirdPartyWarning"
            />
          </div>
          <div className={gridStyles.gridColFull}>
            {circumstances === 'special'
              && (
              <Field
                component={TileRadioAccessible}
                name={pageFields.receiveApplication.formikName}
                title={pageFields.receiveApplication.title}
                tileData={ReceiveApplicationViaEmail}
                tileContainer
                isMandatory
                orientationRow
                classname={styles.tile}
              />
            )}
          </div>
          <div className={gridStyles.gridColFull}>
            {((circumstances === 'special' && (getIn(values, 'ReceiveApplicationViaEmailYourDetailsThirdParty') === 'true')) || circumstances !== 'special')
              && (
              <Field
                component={TileRadioAccessible}
                name={pageFields.receiveCorrespondence.formikName}
                title={pageFields.receiveCorrespondence.title}
                tileData={CorrespondenceRecipient}
                tileContainer
                isMandatory
                orientationColumn
                classname={styles.tileLeft}
                />
            )}
          </div>
        </div>
      </>
    );
}

export default ThirdPartyFormReview;
